import { Button, Col, Divider, Form, Row } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { request } from "../../config/API";

const LoginSocial = ({ isLoading }) => {
  const [authList, setAuthList] = useState();

  const onHandleGoogleLogin = () => {
    window.open(authList?.google?.authUrl, "_self");
  };

  useEffect(() => {
    request.get("/authenticate").then((response) => {
      const data = response?.data?.data;
      setAuthList(data);
    });
  }, []);

  return (
    <>
      <Divider plain>OR</Divider>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item>
            <Button
              icon={<GoogleOutlined></GoogleOutlined>}
              className="br-8"
              style={{
                background: "#cf4332",
                borderColor: "#cf4332",
              }}
              loading={isLoading}
              type="primary"
              htmlType="button"
              size="large"
              block
              onClick={() => onHandleGoogleLogin()}
            >
              Google
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default LoginSocial;
